import React, { useState } from 'react'
import { Message, Modal, InjectedModalProps } from '@nominex/dex-uikit'
import { SlButton, SlCheckbox } from '@shoelace-style/shoelace/dist/react'
import { useExpertModeManager } from 'state/user/hooks'
import { useTranslation } from 'contexts/Localization'

interface ExpertModalProps extends InjectedModalProps {
  setShowConfirmExpertModal: (boolean) => void
  setShowExpertModeAcknowledgement: (boolean) => void
}

const ExpertModal: React.FC<ExpertModalProps> = ({ setShowConfirmExpertModal, setShowExpertModeAcknowledgement }) => {
  const [, toggleExpertMode] = useExpertModeManager()
  const [isRememberChecked, setIsRememberChecked] = useState(false)

  const { t } = useTranslation()

  return (
    <Modal
      title={t('Expert Mode')}
      onBack={() => setShowConfirmExpertModal(false)}
      onDismiss={() => setShowConfirmExpertModal(false)}
      maxWidth="360px"
    >
      <Message variant="warning" mb="24px">
        <div className="text-white">
          {t(
            "Expert mode turns off the 'Confirm' transaction prompt, and allows high slippage trades that often result in bad rates and lost funds.",
          )}
        </div>
      </Message>
      <div className="text-white mb-24">{t('Only use this mode if you know what you’re doing.')}</div>
      <div className="flex items-center mb-24">
        <SlCheckbox
          name="confirmed"
          checked={isRememberChecked}
          onSlChange={() => setIsRememberChecked(!isRememberChecked)}
        />
        <div className="text-dark-gray-100 ml-12 select-none">{t('Don’t show this again')}</div>
      </div>
      <div className="flex flex-col gap-8">
        <SlButton
          variant="primary"
          id="confirm-expert-mode"
          onClick={() => {
            // eslint-disable-next-line no-alert
            if (window.prompt(`Please type the word "confirm" to enable expert mode.`) === 'confirm') {
              toggleExpertMode()
              setShowConfirmExpertModal(false)
              if (isRememberChecked) {
                setShowExpertModeAcknowledgement(false)
              }
            }
          }}
        >
          {t('Turn On Expert Mode')}
        </SlButton>
        <SlButton
          variant="default"
          onClick={() => {
            setShowConfirmExpertModal(false)
          }}
        >
          {t('Cancel')}
        </SlButton>
      </div>
    </Modal>
  )
}

export default ExpertModal
